import { DASHBOARD_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
      path: "/",
      name: "admin-dashboard",
      component: () => import("@/views/admin/AdminDashboardView.vue"),
      pageTitle: "Dashboard",
      requiresAuth: true,
      meta: {
        gate: null,
        requiresSuperAuth: true,
        requiresAuth: true,
        pageTitle: "",
        homePatch: "/admin/dashboard",
      },
    },
    {
      path: "/admin/dashboard",
      name: "admin-dashboard",
      component: () => import("@/views/admin/AdminDashboardView.vue"),
      meta: {
        gate: DASHBOARD_ACCESS,
        requiresSuperAuth: true,
        requiresAuth: true,
        pageTitle: "",
        homePatch: "/admin/dashboard",
      },
    },
    {
      path: "/admin/help",
      name: "help-section",
      component: () => import("@/views/admin/faq/Faq.vue"),
      pageTitle: "FAQ",
      requiresAuth: true,
      breadcrumb: [
        {
          text: "FAQ",
          active: true,
        },
      ],
    },
];
